import layout from '@/layout'

export default {
  path: '/permission',
  component: layout,
  redirect: '/permission/admin',
  name: 'permissionAdmin',
  meta: {
    title: 'permission',
    icon: 'el-icon-lock'
  },
  children: [
    {
      path: '/permission/admin',
      name: 'permissionAdmin',
      component: () => import('@/views/permission/admin/index'),
      meta: {
        title: 'permissionAdmin',
        icon: 'el-icon-lock'
      }
    }
  ]
}
